"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unescape = unescape;
exports.escape = escape;
function unescape(str) {
    return (str + '==='.slice((str.length + 3) % 4)).replace(/-/g, '+').replace(/_/g, '/');
}
function escape(str) {
    return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
